/* eslint-disable react/display-name */
import { Switch, Route } from 'react-router-dom';
import HomePage from './pages';
import LoginPage from './pages/login';
import Error404Page from './pages/404';
import Header from './components/page/Header';
import Footer from './components/page/Footer';
import Page from './components/page/Page';
import Playground from 'src/pages/playground';
import Hero from './components/hero/ImageBackground';
import Title from 'src/components/hero/Title';

const makePage = (title, Component) => (props) =>
  (
    <Page title={title}>
      <Component {...props} />
    </Page>
  );

function App() {
  return (
    <div className="min-h-screen flex flex-col min-w-screen justify-between font-sans">
      <Header title="Emergency News Feed" />
      <Hero bg="bg-hero">
        <Title />
      </Hero>
      <main className="flex-grow">
        <Switch>
          <Route exact path="/login" component={makePage('Login', LoginPage)} />
          <Route exact path={['/', '/home']} component={makePage('Home', HomePage)} />
          <Route exact path={['/Playground']} component={makePage('Playground', Playground)} />

          <Route path="*" component={makePage('Page Not Found', Error404Page)} />
        </Switch>
      </main>
      <Footer
        officeStreet="3075 North Main"
        officeCityState="Spanish Fork, Utah 84660"
        phone="(801) 851-4138"
        EmEmail="EM@utahcounty.gov"
        GRAMAEmail="sheriffrecords@utahcounty.gov"
      />
    </div>
  );
}

export default App;
